import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { DeepPartial, ISearchCashbackWalletRequest, ISearchTransactionRequest, ISearchTransactionResponse, ISearchWalletResponse, ITransactionIndex } from '@lib/interfaces';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TransactionService {
    public environment_url: string;

    public constructor(private readonly http: HttpClient) {
        this.environment_url = environment.api_url;
    }

    public searchTransactions(searchPayload: DeepPartial<ISearchTransactionRequest>): Observable<ISearchTransactionResponse> {
        return this.http.post<ISearchTransactionResponse>(`${this.environment_url}nfront/v1/proxy/transactions:search`, searchPayload);
    }

    public searchWallet(searchPayload: DeepPartial<ISearchCashbackWalletRequest>): Observable<ISearchWalletResponse> {
        return this.http.post<ISearchWalletResponse>(`${this.environment_url}nfront/v1/transactions:search`, searchPayload);
    }

    public fetchTransactionsCount(duration: string): Observable<any> {
        return this.http.get<any>(`${this.environment_url}nfront/v1/proxy/transactions:count?duration=${duration}`);
    }

    public exportTransactionExcelTable(type: string, fields: any, selectedColumns: string[]): Observable<any> {
        return this.http.post<any>(
            `${this.environment_url}nfront/v1/admins/transactions:export?format=XLSX`,
            { ...fields, selected_columns: selectedColumns },
            {
                headers: new HttpHeaders({
                    'content-type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    type,
                }),
                responseType: 'blob' as any,
            },
        );
    }

    public getTransactionDetails(transactionId: string): Observable<ITransactionIndex> {
        return this.http.get<ITransactionIndex>(`${this.environment_url}nfront/v1/proxy/transactions/${transactionId}`);
    }
}
